// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 637 ? "swipeableDrawer" : chunkId) + "." + {"541":"cad6b89f","637":"33afad80"}[chunkId] + ".chunk.js";
};